module.exports = __webpack_public_path__ + "img/4-3.59b234c3.svg";